import { EquipoVentas } from "./EquipoVenta/equipoVentas";
import { EmpresaAfiliadaUsuario } from "./empresaAfiliadas/empresaAfiliadaUsuario";
import { EmpresasAfiliadas } from "./empresasAfiliadas";
import { Proyecto } from "./proyecto";

export class Usuario {
    idEmpresa?: number = 1;
    idEmpresaAfiliada?: number = -1;
    idUsuario?: number = -1;
    idProyecto?: number = -1;
    idGrupo?: number = -1;
    login?: string = "";
    contrasena?: string = "";
    nombre?: string = "";
    fechaNacimiento?: Date;
    descripcion?: string = "";
    idRegion?: number = -1;
    tipo?: string = "";
    avatar?: string = "";
    idCliente?: number = -1;
    devicedId?: string = "";
    estatus?: string = "";
    telefono?: string = "";
    mensaje?: string = "";
    lada?: string = "";
    token?: string = "";
    tipoRegistro?: string = "";
    ZonaHoraria?: string = "";
    Seleccion?: number = -1;
    IdsProyecto?: string = "";
    TotalRegistros?: number = 0;
    Pagina?: number = 0;
    CantidadReg?: number = 10;
    proyectos?: Array<Proyecto> = [];
    idUsuarioUM?: number = -1;
    codigoCreador?: string = "";
    permisoExternos?: number = 0;
    totalTop?: number = 0;
    perfilParseo?: string = "";
    totalScore?: string = "";
    creadorApoyando?: string = "";
    idEquipo?: number = 0;
    titular?: number = 0;
    fechaHoraUM?: Date;
    idEncargado?: number = 0;
    regimenFiscal?: number = 0;
    empresaAfiliadas?: EmpresaAfiliadaUsuario[] = [];
    sP?: number = -1;
    avatarFile?: File;
    idEquipos?: EquipoVentas[] = [];
    idGrupoTelefono?: number = 0;
    usuarioMiembroNomina?: number = 0;
    invitarUsuario?: number = 0;
    tipoPerfil?: string = "";
    cantidadProspectosFacebook?: number = 1;
    idCaracterizacion?: string = "";
    tp?: number = 0;
    id?: number = 0;
    tipoNegocio?: number = 0;
    estatusRuletaUsuario?: number = 1;
    tpp?: number = 0;
    idEstatus?: number = 0;
    linea?: string = "0";
    primerosPasosListos?: number = 0;
    ruletaActiva?: number = 1;
    caracterizacion?: string = "";
    tieneAccesoProyecto?: boolean = true;
    loading?: boolean = false;
}

export class GetQuery {
    tipoRegistro: string;
}

export class RecuperaUsuario {
    idUsuario: number;
    configuracionProyecto: number;
    configuracionMarketing: number;
}

export class EstatusRequest {
    idUsuario: number;
    idModulo: number;
    idEstatus: number;
}


export class HorarioUsuario {
    idHorario: number = 0;
    idUsuario: number = 0;
    diaSemana: string = "";
    horaInicio: string = "";
    horaFin: string = "";
    fechaHoraUM: Date = new Date();
    idUsuarioUM: number = 0;
    horaInicioString: string = "";
    horaFinString: string = "";
    saltoDeHoraString: string = "";
    saltoDeHora: number = 0;
    saltoDeMinutos: number = 0;

}


export class UsuarioLineaAutomatizacionDto {
    idUsuario: number = 0;
    idLinea: number = 0;
    idAutomatizacion: number = 0;
    idUsuarioUM: number = 0;
}